export const DEFAULT_DASHBOARD_FILTERS = {
  chartLeftMetric: "spends",
  chartRightMetric: "revenue",
  chartTimePeriod: "date",
  campaignMetric: "spends",
  campaignTab: "vs",
  performanceView: "both",
  targetingView: "Default",
  targetingPerformer: "top",
  productSummaryView: "product-summary-low-stock-product",
};

export const DASHBOARD_LAYOUT_SECTIONS = [
  { id: "trend_graph", label: "Performance Analysis" },
  { id: "targeting", label: "Targeting Insights" },
  { id: "low_performing_search_terms", label: "Low Performing Search Terms" },
  { id: "campaign_summary", label: "Campaign Summary" },
  { id: "category_product_performance_summary", label: "Category & Product Performance" },
  { id: "product_summary", label: "Product Summary", sellerOnly: true },
];

export const DEFAULT_DASHBOARD_LAYOUT = DASHBOARD_LAYOUT_SECTIONS.map(
  (section) => section.id
);

export function getDashboardLayoutSections(clientType) {
  const includeProductSummary = clientType === "seller";
  return DASHBOARD_LAYOUT_SECTIONS.filter(
    (section) => includeProductSummary || !section.sellerOnly
  );
}

/** Keep saved order, drop unknown keys, and append any current section that is missing. */
export function normalizeDashboardLayout(sequence = [], clientType) {
  const allowed = getDashboardLayoutSections(clientType).map(
    (section) => section.id
  );
  const allowedSet = new Set(allowed);
  const seen = new Set();
  const next = [];

  (sequence || []).forEach((id) => {
    if (!allowedSet.has(id) || seen.has(id)) return;
    seen.add(id);
    next.push(id);
  });

  allowed.forEach((id) => {
    if (!seen.has(id)) next.push(id);
  });

  return next;
}
